"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var material_1 = require("@angular/material");
/**
 * @author Gor.Hakobyan on 12-Apr-18.
 */
var ConfirmPopup = /** @class */ (function () {
    function ConfirmPopup(messageService, data, dialogRef) {
        this.messageService = messageService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.message = data.message;
        this.title = data.title;
        this.confirmOk = data.confirmOk;
    }
    /**
     * get fields names by current language
     * @returns {Observable<string>}
     */
    /**
         * get fields names by current language
         * @returns {Observable<string>}
         */
    ConfirmPopup.prototype.getMessage = /**
         * get fields names by current language
         * @returns {Observable<string>}
         */
    function (messageKey) {
        return this.messageService.getMessage(messageKey);
    };
    ConfirmPopup.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'confirm-popup',
                    template: require('./confirm-popup.component.html'),
                    styles: [require('./confirm-popup.component.css')],
                },] },
    ];
    /** @nocollapse */
    ConfirmPopup.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [material_1.MAT_DIALOG_DATA,] },] },
        { type: material_1.MatDialogRef, },
    ]; };
    return ConfirmPopup;
}());
exports.ConfirmPopup = ConfirmPopup;
//# sourceMappingURL=confirm-popup.component.js.map